module.exports = __webpack_public_path__ + "img/jdcx.d2930537.png";